<template>
  <main class="lines">
    <div v-for="line in lines" :key="line.nb" class="line">
      <div v-for="video in line.videos" :key="video.id" class="video">
        <router-link class="link" :to="'/video/' + video.id" :id="video.id">
          <div class="img-wrapper">
            <img :src="videoImage(video)" />
            <div class="transition">
              <div class="name">{{ video.name }}</div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </main>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted } from "vue";
import { useHead } from "@unhead/vue";
import { useMainStore } from "@/store";
import Video from "@/models/Videos";

export default defineComponent({
  name: "Videos",
  setup() {
    useHead({
      title: "Videos",
    });

    const store = useMainStore();

    onMounted(() => {
      store.fetchVideos();
    });

    const videos = computed(() => store.videos);

    const videoImage = (video: Video) => {
      return process.env.VUE_APP_API_URL + "/static/images/video/" + video.image;
    };

    const videolen = () => {
      return videos.value.length;
    };

    const lines = computed(() => {
      const pack: Array<{}> = [];
      for (let i = 0, nb = 0; i < videos.value.length; i += 3, nb++) {
        let control = 0;
        const line: { nbr: number; videos: Array<Video> } = {
          nbr: nb,
          videos: [],
        };
        control = i < videos.value.length ? line.videos.push(videos.value[i]) : -1;
        control = i + 1 < videos.value.length ? line.videos.push(videos.value[i + 1]) : -1;
        control = i + 2 < videos.value.length ? line.videos.push(videos.value[i + 2]) : -1;
        pack.push(line);
        if (control < 0) break;
      }
      return pack;
    });

    const randomIndex = () => {
      return Math.floor(Math.random() * videolen());
    };

    return {
      videos,
      videoImage,
      videolen,
      lines,
      randomIndex,
    };
  },
});
</script>

<style scoped lang="scss">
$gutter: 3vw;

.lines {
  padding-right: $gutter;
  padding-left: $gutter;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-evenly;
}

.link {
  height: 100%;
  width: 100%;
  text-decoration: none;
}

.video {
  padding: 10px;
}

.img-wrapper {
  width: 100%;
  max-width: 600px;
  overflow: hidden;
  position: relative;
}

.img-wrapper img {
  width: inherit;
}

.img-wrapper:hover img {
  opacity: 0.3;
}

.img-wrapper:hover .transition {
  opacity: 1;
}

.name {
  color: black;
  font-size: 16px;
  padding: 16px 32px;
}

.transition {
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

@media only screen and (min-width: 769px) {
  .line {
    display: flex;
    flex-flow: row nowrap;
    flex: 0 2 auto;
    justify-content: space-evenly;
    align-items: center;
  }
}

@media only screen and (max-width: 768px) {
  .line {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-evenly;
    align-items: center;
  }
}
</style>
